import { render, staticRenderFns } from "./exportzip.vue?vue&type=template&id=96c7958c&"
import script from "./exportzip.vue?vue&type=script&lang=js&"
export * from "./exportzip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports